var map = {
	"./Betting.js": "aCSQ",
	"./CustomerService.js": "+NXo",
	"./Deposit.js": "0WPP",
	"./Discount.js": "PV2E",
	"./My.js": "atUd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yXTM";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/router/module \.js$
// module id = yXTM
// module chunks = 44